import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const dataTableStyleId = 'data-table-theme';

export const dataTableBridgeStyles = {
    'w-data-table': {
        '--local-data-table-border-secondary': tokens.color.border.secondary,
        '--local-data-table-radius-md': tokens.radius.md,
        '--local-data-table-bg-primary': tokens.color.background.primary,
        '--local-data-table-bg-secondary': tokens.color.background.secondary,
        '--local-data-table-spacing-md': tokens.spacing.md,
        '--local-data-table-spacing-xl': tokens.spacing.xl,
        '--local-data-table-text-primary': tokens.color.text.primary,
        '--local-data-table-spacing-2xl': tokens.spacing.twoXl,
    },
};
